module.exports = __webpack_public_path__ + "static/media/7.5b76c889.jpg";